import ProductAccessSwitcher from './ProductAccessSwitcher';

export default ProductAccessSwitcher;
